import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { vaAlertStyles } from './va-alert.styles';
import { renderVaAlertTemplate } from './va-alert.template';

@customElement('va-alert')
export class VaAlert extends LitElement {
  static styles = vaAlertStyles;

  @property({ type: String }) type: 'success' | 'error' | 'info' | 'warning' = 'info';
  @property({ type: Boolean }) dismissable = false;

  render() {
    return renderVaAlertTemplate(this);
  }

  public handleDismiss = () => {
    this.remove();
  };
}
